import {HttpProblemDetails} from "../../model/error/HttpProblemDetails";

export class HttpProblemDetailsError extends Error {
    constructor(public httpProblemDetails: HttpProblemDetails, message?: string) {
        super(message);
        this.name = 'HttpProblemDetailsError';
    }
}